import React from 'react';

const Pokemon = ({ name, species, id }) => {
	return (
		<div className='pokemon-box'>
			<img src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`} alt={name} />
			<h2>{name}</h2>
			<p>{species}</p>
		</div>
	)
}

export default Pokemon;


// WEBPACK FOOTER //
// ./src/components/Pokemon.js